import { fg } from '@atlaskit/platform-feature-flags/fg';

export default {
	get(): boolean {
		return fg('rovo_agents_studio_browse_kit_uplift');
	},
};
